import { createApp } from 'vue'

import { createPinia } from 'pinia'

import '@mdi/font/css/materialdesignicons.css'
import { createVuetify } from 'vuetify'

import 'vuetify/styles'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import '@mdi/font/css/materialdesignicons.css'
import { ru } from 'vuetify/locale'

import { register } from 'swiper/element/bundle'

import App from './App.vue'

import { setupCalendar } from 'v-calendar'

import router from './router/index'

register()

const vuetify = createVuetify({
    components,
    directives,
    icons: {
        defaultSet: 'mdi'
    },
    locale: {
        locale: 'ru',
        messages: { ru }
    }
})

const pinia = createPinia()
const app = createApp(App)

app.use(setupCalendar, {})
app.use(pinia)
app.use(router)
app.use(vuetify)
app.mount('#app')
